<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white">
        تقویم پرداختی
      </q-banner>
    </q-card-section>
    <q-card-section align="center">
      <q-date
          range
          @input="showDetails"
          bordered
          class="q-ma-sm"
          calendar="persian"
          today-btn
          v-model="selectedDate"
          :events="itemEvents"
          event-color="red"
          :landscape="!$q.screen.lt.md">
      </q-date>
    </q-card-section>

    <q-card-section align="center">
      <q-chip square color="indigo" text-color="white" v-if="notPayCheckOptions && notPayCheckOptions.length>0" label="پرداخت نشده">
        <q-badge class="q-ml-xs" :label="lodash.sumBy(notPayCheckOptions, 'Fee').toLocaleString()" color="red"
                 text-color="white"/>
      </q-chip>
      <q-chip square color="indigo" text-color="white" v-if="payCheck && payCheck.length>0" label="پرداخت شده">
        <q-badge class="q-ml-xs" :label="lodash.sumBy(payCheckOptions, 'Fee').toLocaleString()" color="red"
                 text-color="white"/>
      </q-chip>
    </q-card-section>

    <q-card-section>
      <CheckDetails title="چک های پرداخت نشده" :items="lodash.orderBy(notPayCheckOptions,'ExpiryDate')"/>
    </q-card-section>
    <q-card-section>
      <CheckDetails title="چک های پرداخت شده" :items="lodash.orderBy(payCheckOptions, 'ExpiryDate')"/>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import CheckDetails from "@/components/PayDocument/CheckDetails";

export default {
  name: "PayDocument",
  components: {CheckDetails},
  data() {
    return {
      notPayCheck: [],
      payCheck: [],
      notPayCheckOptions: [],
      payCheckOptions: [],
      itemEvents: [],
      selectedDate: ''
    }
  },
  methods: {
    ...mapActions({
      getDocuments: 'Deboters/getPayDocument'
    }),
    fillList() {
      this.getDocuments().then((res) => {
        this.notPayCheck = JSON.parse(res.notPayCheck)
        this.payCheck = JSON.parse(res.payCheck)

        this.notPayCheckOptions = this.notPayCheck
        this.payCheckOptions = this.payCheck

        this.itemEvents = this.notPayCheck.map(item => this.changeDateFormat(item.ExpiryDate))
        this.itemEvents.push(this.payCheck.map(item => this.changeDateFormat(item.ExpiryDate)))
      })
    },
    showDetails(value) {
      if (value) {
        if (value.from !== undefined) {
          this.notPayCheckOptions = this.notPayCheck.filter(
              item => parseInt(item.ExpiryDate) >= parseInt(value.from.replaceAll('/', ''))
                  && parseInt(item.ExpiryDate) <= parseInt(value.to.replaceAll('/', '')))

          this.payCheckOptions = this.payCheck.filter(
              item => parseInt(item.ExpiryDate) >= parseInt(value.from.replaceAll('/', ''))
                  && parseInt(item.ExpiryDate) <= parseInt(value.to.replaceAll('/', '')))
        } else {
          this.notPayCheckOptions = this.notPayCheck.filter(
              item => item.ExpiryDate === parseInt(value.replaceAll('/', '')))

          this.payCheckOptions = this.payCheck.filter(
              item => item.ExpiryDate === parseInt(value.replaceAll('/', '')))
        }
      }else{
        this.notPayCheckOptions = this.notPayCheck
        this.payCheckOptions = this.payCheck
      }
    },
  },
  created() {
    this.fillList()
  }
}
</script>

<style scoped>

</style>